import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  fonts: {
    heading: `Urbanist, sans-serif`,
    body: `Urbanist, sans-serif`,
  },
});

export default theme;
